import React from "react";
import { convertThenFormat } from "../common-data/Converts";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import "../../styles/expense/ClusterManagerPettyCashListsMobile.css";

const ClusterManagerPettyCashListsMobile = ({
  userInfoData,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
  clusterManagerData,
  clusterManagerDataLoading,
}) => {
  const renderPagination = () => {
    if (
      !clusterManagerData?.pagination ||
      clusterManagerData.pagination.length === 0
    )
      return null;

    return (
      <div className="pagination-container">
        <div className="pagination-info">
          Page {isPage} of {clusterManagerData.pagination.length}
        </div>
        <div className="pagination-controls">
          <button
            className={`pagination-btn ${isPage <= 1 ? "disabled" : "enabled"}`}
            disabled={isPage <= 1}
            onClick={() => setIsPage(isPage - 1)}
          >
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path
                fillRule="evenodd"
                d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
              />
            </svg>
          </button>
          <button
            className={`pagination-btn ${
              isPage >= clusterManagerData.pagination.length
                ? "disabled"
                : "enabled"
            }`}
            disabled={isPage >= clusterManagerData.pagination.length}
            onClick={() => setIsPage(isPage + 1)}
          >
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path
                fillRule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
              />
            </svg>
          </button>
        </div>
      </div>
    );
  };

  if (clusterManagerDataLoading) {
    return (
      <div className="cluster-manager-petty-cash-mobile-wrapper">
        <div className="loading-container">
          <ReactVortoxSpinner />
        </div>
      </div>
    );
  }

  return (
    <div className="cluster-manager-petty-cash-mobile-wrapper">
      {!clusterManagerData?.data || clusterManagerData.data.length === 0 ? (
        <div className="empty-state">
          <svg width="64" height="64" fill="currentColor" viewBox="0 0 16 16">
            <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4" />
          </svg>
          <h3>No Cluster Managers</h3>
          <p>No cluster managers found for the current filters.</p>
        </div>
      ) : (
        <>
          {clusterManagerData.data.map((row, index) => {
            const status = row?.status?.toLowerCase();
            const gyms = row?.cluster_mapped_gyms || [];

            return (
              <div key={index} className="cluster-manager-card">
                {/* Header with Manager Info and Status */}
                <div className="card-header">
                  <div className="manager-info">
                    <h3 className="manager-name">{row?.name || "NA"}</h3>
                    <div className="manager-contact">
                      {row?.email && <div>{row.email}</div>}
                      {row?.mobile && <div>{row.mobile}</div>}
                    </div>
                  </div>
                  <div className="status-section">
                    <span
                      className={`status-badge ${
                        status === "active" ? "active" : "inactive"
                      }`}
                    >
                      {row?.status || "NA"}
                    </span>
                  </div>
                </div>

                {/* Balance Section */}
                <div className="balance-section">
                  <div className="balance-grid">
                    <div className="balance-item current">
                      <div className="balance-label">Current Balance</div>
                      <div className="balance-amount">
                        ₹{convertThenFormat(row?.petty_cash || 0)}
                      </div>
                    </div>
                    <div className="balance-item">
                      <div className="balance-label">Total Requested</div>
                      <div className="balance-amount">
                        ₹
                        {convertThenFormat(
                          row?.total_requested_petty_cash || 0
                        )}
                      </div>
                    </div>
                    <div className="balance-item">
                      <div className="balance-label">Total Approved</div>
                      <div className="balance-amount">
                        ₹{convertThenFormat(row?.total_pending_petty_cash || 0)}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Mapped Gyms Section */}
                <div className="gyms-section">
                  <div className="gyms-header">
                    <svg
                      width="16"
                      height="16"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8.5 5a.5.5 0 0 0-1 0v1.5H6a.5.5 0 0 0 0 1h1.5V9a.5.5 0 0 0 1 0V7.5H10a.5.5 0 0 0 0-1H8.5z" />
                      <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z" />
                    </svg>
                    <span>Mapped Gyms</span>
                    <span className="gyms-count">
                      {gyms.length} Gym{gyms.length !== 1 ? "s" : ""}
                    </span>
                  </div>

                  {gyms.length > 0 ? (
                    <div className="gyms-list">
                      {gyms.map((gym, gymIndex) => (
                        <div key={gym.gym_id || gymIndex} className="gym-item">
                          {gym.gym_name}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="no-gyms">No gyms mapped</div>
                  )}
                </div>

                {/* Action Button */}
                <div className="card-actions">
                  <button
                    className="action-btn"
                    onClick={() => {
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        cardName: "cluster_manager_details",
                        rowData: row,
                      }));
                    }}
                  >
                    <svg
                      width="16"
                      height="16"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                      <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
                    </svg>
                    View Details
                  </button>
                </div>
              </div>
            );
          })}

          {renderPagination()}
        </>
      )}
    </div>
  );
};

export default ClusterManagerPettyCashListsMobile;
